import type {MotionProps, Variants} from 'framer-motion'

export const LeftRightVariants: Variants = {
  left: {
    x: '-100%',
  },
  right: {
    x: '100%',
  },
  center: {
    x: '0%',
  },
}

export const LeftAnimation = {
  variants: LeftRightVariants,
  initial: 'left',
  animate: 'center',
  exit: 'left',
} satisfies MotionProps

export const RightAnimation = {
  variants: LeftRightVariants,
  initial: 'right',
  animate: 'center',
  exit: 'right',
} satisfies MotionProps
